import fetch from "../utils/fetch";
import sessionStorage from "../utils/session-storage";

const cacheKey = "pc-ident";

let memo;

export const clearCache = () => {
  sessionStorage.removeItem(cacheKey);
  memo = undefined;
};

const identity = async () => {
  if (memo) {
    return memo;
  }

  if (sessionStorage.getItem(cacheKey)) {
    memo = Promise.resolve(JSON.parse(sessionStorage.getItem(cacheKey)));
  } else {
    const now = Date.now() / 1000;
    memo = fetch("https://apix.purecars.com/trade/api/v1/identity").then(
      async resp => {
        const { time, remoteId } = await resp.json();
        const ident = {
          timeDifference: Math.floor(parseInt(time, 10) - now),
          remoteId
        };
        sessionStorage.setItem(cacheKey, JSON.stringify(ident));
        return ident;
      }
    );
  }
  return memo;
};

export default identity;
